import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

/**
 * The feature flag is used to enable the Freemium version of RateShopper to users
 * @todo Eventually, replace this with the useFreemiumRateShopperFeatureGate and useAutomatedRateShopperFeatureGate hooks.
 * @returns {boolean}
 */
export const useEnableRateShopperFreemium = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableRateShopperFreemium);
};
